export const Theme = {
    name: 'theme',
    tokens: {
        colors: {
            border: {
                primary: { value: 'black' },
            },

        },
        components: {
            radiogroup: {
                radio: {
                    borderColor: { value: '#2a2f2e' },
                    _checked: {
                        color: { value: '#95c0ea' },
                    },
                },
            },
            checkbox: {
                button: {
                    color: { value: '#2a2f2e' },
                },
                icon: {
                    backgroundColor: { value: '#95c0ea' },
                }
            },
            button: {
                
                primary: {
                    backgroundColor: { value: '#2a2f2e' },
                    color: { value: '#95c0ea' },

                    _hover: {
                        backgroundColor: { value: '#95c0ea' },
                        color: { value: '#2a2f2e' },
                    },
                    _focus: {
                        backgroundColor: { value: '#2a2f2e' },
                        color: { value: '#95c0ea' },
                        borderColor: { value: '#95c0ea' },
                        borderWidth: { value: '3px' },
                        borderStyle: { value: 'solid' }
                    },
                    _active: {
                        backgroundColor: { value: '#2a2f2e' },
                        color: { value: '#95c0ea' },
                        borderColor: { value: '#95c0ea' },
                        borderWidth: { value: '3px' },
                        borderStyle: { value: 'solid' }
                    },
                    _disabled: {
                        backgroundColor: { value: 'transparent' },
                        borderColor: { value: '{colors.neutral.30}' },
                    },
                },
            },
        },
    },
};